import { useShouldShowDevTeamFeature } from './_base';

export const useEventsPerspectiveFeature: () => boolean = useShouldShowDevTeamFeature;
